// extracted by mini-css-extract-plugin
export default {"About__Section":"About_About__Section__jHOH6","Left__Icon__Text":"About_Left__Icon__Text__I8ELF","Icon":"About_Icon__UvLUA","Text":"About_Text__UY1fD"};